import { Component } from '@theme/component';
import { debounce, onDocumentLoaded } from '@theme/utilities';
import {
  ThemeEvents,
  CartUpdateEvent,
  CartAddEvent,
} from '@theme/events';

class SearchPopupFom extends Component {
    #abortController = null;
    #predictiveAbortController = null;
    connectedCallback() {
        super.connectedCallback();
        this.#init();
    }
    #init(){
        this.initSearchForm();
        this.initProdSlider();
    }
    initSearchForm(){
        this.querySelectorAll('.popup-search-form').forEach(ele => {
            ['click', 'focus'].forEach(eventType => {
                ele.querySelectorAll('.header__search-field, .header__search-button').forEach( el => {
                    el.addEventListener(eventType, e => {
                        e.preventDefault();
                        document.body.classList.add('search-active');
                    })
                })
            });
            // DEED: wait until the visitor pauses typing and skip keys that do not change the term
            let lastValue = ele.querySelector('.header__search-field').value.trim();
            const onInput = debounce(() => {
                const value = ele.querySelector('.header__search-field').value.trim();
                if (value === lastValue) return;
                lastValue = value;
                this.updateSearchContent(value);
            }, 250);
            ele.querySelector('.header__search-field').addEventListener('keyup', onInput);
            ele.querySelector('.header__search-field').addEventListener('input', onInput);
        })
        const value = this.querySelector('.header__search-field').value.trim();
        if(value){
            this.updateSearchContent(value);
        }
        this.querySelectorAll('.popup-search_close,.search-popup-from__bg,.header__search-form-chevron').forEach(ele => {
            ele.addEventListener('click', e => {
                e.preventDefault();
                document.body.classList.remove('search-active');
            })
        })
    }
    async updateSearchContent(terms = null){
        this.querySelector('.search-container').classList.add('ajax-loading');
        this.updateSuggestions(terms)
        const html = await this.fetchSearch(terms);
        this.querySelector('.search-container').innerHTML = html.innerHTML;
        this.initProdSlider();
        this.querySelector('.search-container').classList.remove('ajax-loading');
    }
    async updateSuggestions(terms = null){
        this.querySelector('.search-popup__sugg-container').classList.add('ajax-loading');
        const ul = this.querySelector('.search-popup__sugg-list');
        if(terms){
            const sugg = await this.fetchPredictiveSearch(terms);
            const template = this.querySelector('#search-popup__sugg-list-template')
            const wrapper = document.createElement('div');
            wrapper.innerHTML = template.innerHTML;
            const item = wrapper.querySelector('li');
            const result = [...sugg.resources.results.collections, ...sugg.resources.results.queries];
            this.querySelector('.search-popup__sugg-row').classList.toggle('active', result.length)

            // const suggLink = this.querySelector('.search-popup__sugg-link');
            // if(suggLink){
            //     const url = new URL(suggLink.href);
            //     url.searchParams.set('q', terms);
            //     suggLink.href = url.toString();
            //     suggLink.querySelector('.terms').innerText = terms;
            // }

            ul.innerHTML = '';
            result.forEach(collection => {
                item.querySelector('a').dataset.keyword = collection.title || collection.text;
                // DEED: collections link to the collection page, search suggestions to their search
                item.querySelector('a').href = collection.url;

                // item.querySelector('a').href = (new URL(item.querySelector('a').href)).set('q', collection.title);
                // item.querySelector('span').innerHTML = collection.title || collection.text;
                item.querySelector('span').innerHTML = this.spanify(collection.title || collection.text, terms);
                ul.append(item.cloneNode(true))
            });
        } else {
            ul.innerHTML = '';
            this.querySelector('.search-popup__sugg-row').classList.remove('active')
        }
        // this.querySelector('.search-popup__sugg-container').innerHTML = html.innerHTML;
        this.querySelector('.search-popup__sugg-container').classList.remove('ajax-loading');
    }
    spanify(text, part){
        // const text = "I love apple pie and green apples.";
        // const wordToMatch = "apple";

        // 'g' means global (all matches), 'i' means case-insensitive
        // DEED: escape the typed term, so characters like ( or + do not break the highlight
        const regex = new RegExp(String(part).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), "gi");

        return text.replace(regex, (match) => {
            return `<span class="highlight">${match}</span>`;
        });
    }
    fetchSearch(terms = null){
        if (this.#abortController) {
            this.#abortController.abort();
        }
        this.#abortController = new AbortController();
        const signal = this.#abortController.signal;
        const url = Theme.routes.search_url + '?type=product&view=ajax' + (terms ? '&q=' + encodeURIComponent(terms) : '');

        return fetch(url, {signal}).
        then((response) => {
            if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
        }).
        then((response) => {
            const parser = document.createElement('div');
            parser.innerHTML = response;
            const ajaxContainer = parser.querySelector('[data-ajax-container="search"]');
            return ajaxContainer;
        });
    }
    fetchPredictiveSearch(terms = null){
        if (this.#predictiveAbortController) {
            this.#predictiveAbortController.abort();
        }
        this.#predictiveAbortController = new AbortController();
        const signal = this.#predictiveAbortController.signal;
        const url = Theme.routes.search_url + '/suggest.json?' + (terms == null ? '' : 'q=' + encodeURIComponent(terms) + '&resources[type]=collection,query&resources[options][fields]=title&resources[limit]=3' );

        return fetch(url, {signal}).
        then((response) => {
            if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
    }
    initProdSlider(){
        new Swiper(this.querySelector('.search-popup__prod-swiper'),{
            slidesPerView: 'auto',
            freeMode: {
                enabled: true,
                sticky: true,
                momentumRatio: 0.8,
            },
        })

    }
}
if (!customElements.get('search-popup-from')) {
  customElements.define('search-popup-from', SearchPopupFom);
}